import {$,_,Backbone,Marionette,moment} from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'

import NumberDiscountSortTabsTpl from '../../templates/pricediscounts/NumberDiscountSortTabsTpl.html'

export default InboomaBaseView.extend({

    template : NumberDiscountSortTabsTpl,
    el : '#inb-c-main-sort-nav',

    ui : {
        li : 'li.tabs-title:not(.is-active)'
    },

    events : {
        'click @ui.li' : '_changeCollectionSort',
    },

    initialize () {
        this.render();
    },

    onRender () {
        // https://foundation.zurb.com/sites/docs/sticky.html
    },

    _changeCollectionSort (el) {

        el = $(el.currentTarget);
        el.parent().find('.is-active').removeClass('is-active');
        el.addClass('is-active');
        this.collection.setSort(el.attr('data-inb-val'));

        return false;

    }
});